import React, { useState } from "react";
import isopurelogo from "../assets/ISO-Logo-White.png";
import "./isopure.css";
import cardimg from "../assets/PImage.jfif";
import checkedg from "../assets/checked-green.png";
import alreadysc from "../assets/already-scannned.png";
import fakex from "../assets/fakex.png";
import { toast } from "react-hot-toast";
import Loader from "../components/Loader";
import IsopureService from "../services/IsopureService";

const IsopureAuth = () => {
  const isopureService = new IsopureService();
  const [formData, setFormData] = useState({
    SerialNo: "",
    BatchNo: ""
  });

  const [errors, setErrors] = useState({ SerialNo: "", BatchNo: "" });

  const [state, setState] = useState({
    loading: false,
    isAuthenticated: false,
    isGenuine: false,
    isAlreadyScanned: false,
    isFake: false,
    productName: ""
  });

  function changeHandler(event) {
    setFormData((prevData) => ({
      ...prevData,
      [event.target.name]: event.target.value
    }));
  }

  async function submitHandler(event) {
    event.preventDefault();

    const validationErrors = {};

    if (!formData.SerialNo) {
      validationErrors.SerialNo = "Enter Serial No.";
    }

    if (!formData.BatchNo) {
      validationErrors.BatchNo = "Enter Batch No.";
    }

    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setState((prevData) => ({
        ...prevData,
        loading: true
      }));
      event.preventDefault();
      try {
        const obj = {
          SerialNo: formData.SerialNo,
          BatchNo: formData.BatchNo
        };
        isopureService.CheckIsopureQR(obj).then((response) => {
          setState((prevData) => ({
            ...prevData,
            loading: false
          }));
          if (response.responseCode == 200) {
            setState((prevData) => ({
              ...prevData,
              loading: false,
              isAuthenticated: true,
              isGenuine: true,
              isAlreadyScanned: false,
              isFake: false,
              productName: response.productName
            }));
          } else if (response.responseCode == 201) {
            setState((prevData) => ({
              ...prevData,
              loading: false,
              isAuthenticated: true,
              isGenuine: false,
              isAlreadyScanned: true,
              isFake: false,
              productName: response.productName
            }));
          } else if (response.responseCode == 400) {
            setState((prevData) => ({
              ...prevData,
              loading: false,
              isAuthenticated: true,
              isGenuine: false,
              isAlreadyScanned: false,
              isFake: true,
              productName: ""
            }));
          }
        });
      } catch (error) {
        setState((prevData) => ({
          ...prevData,
          loading: false,
          isAuthenticated: false
        }));
        toast.error("Something went wrong");
      }
    }
  }

  return (
    <div>
      {state.loading ? (
        <Loader />
      ) : (
        <div>
          <section hidden={state.isAuthenticated} id="isopure">
            <div className="container-fluid fcont">
              <div className="row frowi">
                <div className="col-md-12">
                  <img
                    src={isopurelogo}
                    className="isopurelogo"
                    alt="slider"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-md-12 svypfcol">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-md-12 vfpcol">
                        <span>Verify your product</span>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="container-fluid upcardcont">
                        <div className="card">
                          <div className="row g-0">
                            {/* Left Side - Form */}
                            <div className="col-md-6 formcoltext">
                              <form
                                className="formone"
                                onSubmit={submitHandler}
                              >
                                <div className="text-left">
                                  <span>
                                    <label className="form-label">
                                      Serial No
                                    </label>
                                  </span>
                                  <span className="mand">*</span>
                                  <input
                                    type="number"
                                    value={formData.SerialNo}
                                    onChange={changeHandler}
                                    name="SerialNo"
                                    className="form-control"
                                    placeholder="Enter Serial No."
                                  />
                                  {errors.SerialNo && (
                                    <div className="text-red-500 mb-3">
                                      {errors.SerialNo}
                                    </div>
                                  )}
                                </div>

                                <div className="text-left mt-4">
                                  <span>
                                    <label className="form-label">
                                      Batch No
                                    </label>
                                  </span>
                                  <span className="mand">*</span>
                                  <input
                                    type="text"
                                    value={formData.BatchNo}
                                    onChange={changeHandler}
                                    name="BatchNo"
                                    className="form-control"
                                    placeholder="Enter Batch No."
                                  />
                                  {errors.BatchNo && (
                                    <div className="text-red-500  mb-3">
                                      {errors.BatchNo}
                                    </div>
                                  )}
                                </div>

                                <div className="row mt-4">
                                  <div className="col-md-12 mt-4">
                                    <button className="btn btn-primary w-100 verifybtn">
                                      Verify
                                    </button>
                                  </div>
                                </div>
                              </form>
                            </div>

                            {/* Right Side - Image */}
                            <div className="col-md-6">
                              <div className="row">
                                <div className="col-md-12 imgfcol">
                                  <div className="row">
                                    <div className="col-md-12 imgscol">
                                      <img
                                        src={cardimg}
                                        className=""
                                        alt="slider"
                                        loading="lazy"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-12 imgtcol mt-3">
                                  <span>
                                    *Serial number can be found on the
                                    authenticity label. For the batch code,
                                    kindly refer to the back of the product
                                    pack.
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-2">
                      <div className="col-md-12 vypcol">
                        <span className="powerby">
                          Powered by{" "}
                          <span className="holostik">
                            <a href="https://holostik.com/" target="_blank">
                              Holostik
                            </a>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section hidden={!state.isAuthenticated} id="isopure product-result">
            <div className="container-fluid fcont">
              <div className="row frowi">
                <div className="col-md-12">
                  <img
                    src={isopurelogo}
                    className="isopurelogo"
                    alt="slider"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-md-12 svypfcol">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-md-12 vfpcol">
                        <span>Product Verification Result</span>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="container-fluid upcardcont">
                        <div className="card">
                          <div hidden={!state.isGenuine} className="row">
                            <div className="col-md-12 gfaimgcolo d-flex justify-content-center">
                              <img
                                src={checkedg}
                                className=""
                                alt="slider"
                                loading="lazy"
                              />
                            </div>
                            <div className="col-md-12 d-flex justify-content-center">
                              <span className="thanks_text">
                                Thanks for Buying Genuine Product
                              </span>
                            </div>
                          </div>
                          {/* already scanned */}
                          <div hidden={!state.isAlreadyScanned} className="row">
                            <div className="col-md-12 gfaimgcol d-flex justify-content-center">
                              <img
                                src={alreadysc}
                                className=""
                                alt="slider"
                                loading="lazy"
                              />
                            </div>
                            <div className="col-md-12 d-flex justify-content-center">
                              <span className="already_text">
                                Product Already Scanned
                              </span>
                            </div>
                          </div>
                          {/* fake */}
                          <div hidden={!state.isFake} className="row">
                            <div className="col-md-12 gfaimgcol d-flex justify-content-center">
                              <img
                                src={alreadysc}
                                className=""
                                alt="slider"
                                loading="lazy"
                              />
                            </div>
                            <div className="col-md-12 mt-2 d-flex justify-content-center">
                              <span>
                                Seems you’ve entered incorrect details. Please
                                try again or connect with customer care to help
                                authenticate your product.
                              </span>
                            </div>
                          </div>

                          <div
                            hidden={!state.productName != ""}
                            className="row p_descrow"
                          >
                            <div className="col-md-12 d-flex justify-content-center">
                              <span className="p_name">
                                {state.productName}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* contact detail */}
                    <div className="row d-flex justify-content-center mt-5">
                      <div className="col-md-12 contact_headcol">
                        <span className="contact_headf">
                          In case of any queries & complaints please contact our
                          Customer Care Team.
                        </span>
                      </div>
                      <div className="row mt-4">
                        <div className="col-md-12">
                          <ul className="contact_dul">
                            <li className="email">
                              <span className="icn mr-2">
                                <i class="bi bi-telephone-fill"></i>
                              </span>
                              <a href="tel:+911149594959">+91-11-49594959</a>
                            </li>
                            <li className="email">
                              <span className="icn mr-2">
                                <i class="bi bi-envelope-fill"></i>
                              </span>{" "}
                              <a href="mailto:indiacustomercare@glanbia.com">
                                indiacustomercare@glanbia.com
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    {/* end contact detail */}
                  </div>
                </div>
              </div>
              {/* powered by holostik */}
              <div className="row rvypcol mt-2">
                <div className="col-md-12 vypcol ">
                  <span className="powerby">
                    Powered by{" "}
                    <span className="holostik">
                      <a href="https://holostik.com/" target="_blank">
                        Holostik
                      </a>
                    </span>
                  </span>
                </div>
              </div>
              {/* end */}
            </div>
          </section>
        </div>
      )}
    </div>
  );
};

export default IsopureAuth;
